/**
 * Os módulos da lista lateral do modo Otto: os da vitrine, na ordem do catálogo, cada um com o endereço real do módulo e
 * o cadeado quando o plano da conta não o tem (`partitionNavByEntitlement`). Função pura: o layout só consome o resultado.
 */
import { SHOWCASE_MODULES } from '@/features/showcase';
import { partitionNavByEntitlement } from '@touchworks/shared/platform/navigation.js';

/**
 * @param {{
 *   navItems: object[],
 *   ctx: { experience: string, hasFeature: (key: string) => boolean, isTrial?: boolean, isSuper?: boolean },
 *   pathFor: (item: object) => string,
 *   pathname: string,
 * }} input `navItems`: itens do catálogo já com o ícone resolvido (os de `MAIN_NAV` e `CORE_NAV`)
 * @returns {{ key: string, label: string, icon: import('react').ElementType, to: string, active: boolean, locked: boolean }[]}
 */
export function buildOttoShellModules({ navItems, ctx, pathFor, pathname }) {
    const items = SHOWCASE_MODULES
        .map((module) => {
            const navItem = navItems.find((item) => item.key === module.navKey);
            return navItem ? { ...navItem, feature: module.feature } : null;
        })
        .filter(Boolean);

    const lockedKeys = new Set(partitionNavByEntitlement(items, ctx).locked.map((item) => item.key));

    return items.map((item) => {
        const to = pathFor(item);
        return { key: item.key, label: item.label, icon: item.icon, to, active: pathname.startsWith(to), locked: lockedKeys.has(item.key) };
    });
}
